// extracted by mini-css-extract-plugin
export default {"poi":"Poi_poi__4-Hk1"};